import { Routes } from '@angular/router';
import {RegionalDetailViewComponent} from "./regional-detail-view/regional-detail-view.component";
import {HomeComponent} from "./home/home.component";
import {SeasonGuard} from "./core/guards/season.guard";

export const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: ':season', component: HomeComponent, canActivate: [SeasonGuard] },
    { path: 'teams/:teamId', component: HomeComponent },
    { path: 'regional/:id', component: RegionalDetailViewComponent }, // no validation
    { path: ':season/regional/:id', component: RegionalDetailViewComponent, canActivate: [SeasonGuard] },
    { path: 'teams', redirectTo: '' },
    { path: ':season/teams', redirectTo: ':season' },
    { path: ':season/teams/:teamId', component: HomeComponent, canActivate: [SeasonGuard] },
];
